import Swiper from 'swiper';
import { Navigation, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default function initGenericSliders() {
    // Find all slider containers
    const sliders = document.querySelectorAll('[data-swiper]');

    sliders.forEach((slider) => {
        // Parse options from data attribute
        const options = JSON.parse(slider.getAttribute('data-swiper-options') || '{}');

        // Select custom navigation elements
        const nextButton = slider.closest('.slider-container').querySelector('.rscas-swiper-button-next');
        const prevButton = slider.closest('.slider-container').querySelector('.rscas-swiper-button-prev');

        // Debug missing navigation buttons
        if (!nextButton || !prevButton) {
            console.error('Swiper navigation buttons are missing for:', slider);
            return; // Prevent Swiper initialization
        }

        const defaultSlidesPerView = 2.5;

        // Add default settings
        const swiperOptions = {
            modules: [Navigation, Autoplay, EffectFade],
            loop: false,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            effect: options.effect || 'slide',
            speed: options.speed || 800,
            slidesPerView: options.slidesPerView || defaultSlidesPerView,
            breakpoints: {
                0: {
                    slidesPerView: 'auto',
                },
                768: {
                    slidesPerView: options.slidesPerViewMobile || 1.5,
                },
                1024: {
                    slidesPerView: options.slidesPerViewDesktop || 2.5,
                },
            },
            ...options,
        };

        try {
            // Initialize Swiper
            new Swiper(slider, swiperOptions);
        } catch (error) {
            console.error('Swiper initialization failed for:', slider, error);
        }
    });
}
